/**
 * Centralized display naming utilities
 * Removes "Option A/B/C" letter labels from UI
 * Keeps optionId internal for analytics and debugging only
 */

/**
 * Get display title for an option (without "Option X:" prefix)
 * @param option - The option data from the recommendation engine
 * @returns Friendly display name without letter/ID prefix
 */
export function getOptionDisplayTitle(option: any): string {
  if (!option) return 'System option';
  
  // If the option has a clean title already without "Option X:", use it
  if (option.title && !option.title.startsWith('Option ')) {
    return option.title;
  }
  
  // Otherwise construct from boilerLabel and waterLabel
  const boilerLabel = option.boilerLabel || option.boiler || 'System';
  const waterLabel = option.water && option.water !== 'on_demand' 
    ? ` + ${option.waterLabel || option.water.replace(/_/g, ' ')}`
    : '';
  
  return `${boilerLabel}${waterLabel}`;
}

/**
 * Get short system name for compact display
 * @param option - The option data
 * @returns Short name like "System Boiler" or "Combi Boiler"
 */
export function getSystemShortName(option: any): string {
  if (!option) return 'System';
  return option.boilerLabel || option.boiler || 'System';
}
